var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-wrapper',[_c('button',{on:{"click":_vm.updateDate}},[_vm._v("Click")]),_c('month',{attrs:{"date":_vm.date}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }